var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("ValidationObserver", {
    scopedSlots: _vm._u([
      {
        key: "default",
        fn: function({ handleSubmit }) {
          return [
            _c("TermsAndConditions", {
              attrs: {
                "open-modal": _vm.openModal,
                "orp-details": _vm.prpDetails
              },
              on: {
                "close-modal": function($event) {
                  return _vm.closeTermsAndConditions()
                }
              }
            }),
            _vm._v(" "),
            !_vm.isSuccess
              ? _c(
                  "form",
                  {
                    staticClass: "login-form custom-form",
                    attrs: { id: "login-form", novalidate: "" },
                    on: {
                      submit: function($event) {
                        $event.preventDefault()
                        return handleSubmit(_vm.onSubmit)
                      }
                    }
                  },
                  [
                    _c(
                      "div",
                      { staticClass: "row success-message text-center m-b-20" },
                      [
                        _c("h1", { staticClass: "title md-title" }, [
                          _c("span", {
                            staticClass:
                              "publisher-registration-welcome-message"
                          })
                        ]),
                        _vm._v(" "),
                        _vm.prpDetails.description
                          ? _c("p", { staticClass: "subtitle p-t-10 p-b-10" }, [
                              _vm._v(
                                "\n        " +
                                  _vm._s(_vm.prpDetails.description) +
                                  "\n      "
                              )
                            ])
                          : _vm._e(),
                        _vm._v(" "),
                        _c("p", {
                          directives: [
                            {
                              name: "t",
                              rawName: "v-t",
                              value: "PRP_SUB_HEADER",
                              expression: "'PRP_SUB_HEADER'"
                            }
                          ],
                          staticClass: "subtitle p-b-15"
                        })
                      ]
                    ),
                    _vm._v(" "),
                    _c("ValidationProvider", {
                      attrs: { rules: "required" },
                      scopedSlots: _vm._u(
                        [
                          {
                            key: "default",
                            fn: function({ errors }) {
                              return [
                                _c(
                                  "fieldset",
                                  {
                                    staticClass:
                                      "login-form__field input__wrap",
                                    class: { "error-focus": errors.length > 0 }
                                  },
                                  [
                                    _c("input", {
                                      directives: [
                                        {
                                          name: "model",
                                          rawName: "v-model",
                                          value: _vm.companyName,
                                          expression: "companyName"
                                        }
                                      ],
                                      staticClass:
                                        "login-form__field__input required",
                                      class: {
                                        error: errors.length > 0,
                                        valid:
                                          _vm.companyName.length > 0 &&
                                          errors.length == 0
                                      },
                                      attrs: {
                                        id: "companyName",
                                        type: "text",
                                        name: "companyName",
                                        required: ""
                                      },
                                      domProps: { value: _vm.companyName },
                                      on: {
                                        input: function($event) {
                                          if ($event.target.composing) return
                                          _vm.companyName = $event.target.value
                                        }
                                      }
                                    }),
                                    _vm._v(" "),
                                    _c("label", {
                                      directives: [
                                        {
                                          name: "t",
                                          rawName: "v-t",
                                          value: "INPUT_BUSINESS_NAME",
                                          expression: "'INPUT_BUSINESS_NAME'"
                                        }
                                      ],
                                      staticClass: "login-form__field__label",
                                      attrs: { for: "companyName" }
                                    }),
                                    _vm._v(" "),
                                    errors.length > 0
                                      ? _c(
                                          "div",
                                          {
                                            staticClass: "error-tooltip__wrap"
                                          },
                                          [
                                            _c("h4", {
                                              directives: [
                                                {
                                                  name: "t",
                                                  rawName: "v-t",
                                                  value:
                                                    "INPUT_BUSINESS_NAME_ERROR",
                                                  expression:
                                                    "'INPUT_BUSINESS_NAME_ERROR'"
                                                }
                                              ],
                                              staticClass:
                                                "menu-link up-text error-tooltip__content"
                                            }),
                                            _vm._v(" "),
                                            _c("p", {
                                              directives: [
                                                {
                                                  name: "t",
                                                  rawName: "v-t",
                                                  value:
                                                    "INPUT_BUSINESS_NAME_ERROR_DESCRIPTION",
                                                  expression:
                                                    "'INPUT_BUSINESS_NAME_ERROR_DESCRIPTION'"
                                                }
                                              ],
                                              staticClass: "description"
                                            })
                                          ]
                                        )
                                      : _vm._e()
                                  ]
                                )
                              ]
                            }
                          }
                        ],
                        null,
                        true
                      )
                    }),
                    _vm._v(" "),
                    _c("ValidationProvider", {
                      attrs: { rules: "required" },
                      scopedSlots: _vm._u(
                        [
                          {
                            key: "default",
                            fn: function({ errors }) {
                              return [
                                _c(
                                  "fieldset",
                                  {
                                    staticClass:
                                      "login-form__field input__wrap",
                                    class: { "error-focus": errors.length > 0 }
                                  },
                                  [
                                    _c("input", {
                                      directives: [
                                        {
                                          name: "model",
                                          rawName: "v-model",
                                          value: _vm.firstName,
                                          expression: "firstName"
                                        }
                                      ],
                                      staticClass:
                                        "login-form__field__input required",
                                      class: {
                                        error: errors.length > 0,
                                        valid:
                                          _vm.firstName.length > 0 &&
                                          errors.length == 0
                                      },
                                      attrs: {
                                        id: "firstName",
                                        type: "text",
                                        name: "firstName",
                                        required: ""
                                      },
                                      domProps: { value: _vm.firstName },
                                      on: {
                                        input: function($event) {
                                          if ($event.target.composing) return
                                          _vm.firstName = $event.target.value
                                        }
                                      }
                                    }),
                                    _vm._v(" "),
                                    _c("label", {
                                      directives: [
                                        {
                                          name: "t",
                                          rawName: "v-t",
                                          value: "INPUT_FIRST_NAME",
                                          expression: "'INPUT_FIRST_NAME'"
                                        }
                                      ],
                                      staticClass: "login-form__field__label",
                                      attrs: { for: "firstName" }
                                    }),
                                    _vm._v(" "),
                                    errors.length > 0
                                      ? _c(
                                          "div",
                                          {
                                            staticClass: "error-tooltip__wrap"
                                          },
                                          [
                                            _c("h4", {
                                              directives: [
                                                {
                                                  name: "t",
                                                  rawName: "v-t",
                                                  value:
                                                    "INPUT_FIRST_NAME_ERROR",
                                                  expression:
                                                    "'INPUT_FIRST_NAME_ERROR'"
                                                }
                                              ],
                                              staticClass:
                                                "menu-link up-text error-tooltip__content"
                                            }),
                                            _vm._v(" "),
                                            _c("p", {
                                              directives: [
                                                {
                                                  name: "t",
                                                  rawName: "v-t",
                                                  value:
                                                    "INPUT_FIRST_NAME_ERROR_DESCRIPTION",
                                                  expression:
                                                    "'INPUT_FIRST_NAME_ERROR_DESCRIPTION'"
                                                }
                                              ],
                                              staticClass: "description"
                                            })
                                          ]
                                        )
                                      : _vm._e()
                                  ]
                                )
                              ]
                            }
                          }
                        ],
                        null,
                        true
                      )
                    }),
                    _vm._v(" "),
                    _c("ValidationProvider", {
                      attrs: { rules: "required" },
                      scopedSlots: _vm._u(
                        [
                          {
                            key: "default",
                            fn: function({ errors }) {
                              return [
                                _c(
                                  "fieldset",
                                  {
                                    staticClass:
                                      "login-form__field input__wrap",
                                    class: { "error-focus": errors.length > 0 }
                                  },
                                  [
                                    _c("input", {
                                      directives: [
                                        {
                                          name: "model",
                                          rawName: "v-model",
                                          value: _vm.lastName,
                                          expression: "lastName"
                                        }
                                      ],
                                      staticClass:
                                        "login-form__field__input required",
                                      class: {
                                        error: errors.length > 0,
                                        valid:
                                          _vm.lastName.length > 0 &&
                                          errors.length == 0
                                      },
                                      attrs: {
                                        id: "lastName",
                                        type: "text",
                                        name: "lastName",
                                        required: ""
                                      },
                                      domProps: { value: _vm.lastName },
                                      on: {
                                        input: function($event) {
                                          if ($event.target.composing) return
                                          _vm.lastName = $event.target.value
                                        }
                                      }
                                    }),
                                    _vm._v(" "),
                                    _c("label", {
                                      directives: [
                                        {
                                          name: "t",
                                          rawName: "v-t",
                                          value: "INPUT_LAST_NAME",
                                          expression: "'INPUT_LAST_NAME'"
                                        }
                                      ],
                                      staticClass: "login-form__field__label",
                                      attrs: { for: "lastName" }
                                    }),
                                    _vm._v(" "),
                                    errors.length > 0
                                      ? _c(
                                          "div",
                                          {
                                            staticClass: "error-tooltip__wrap"
                                          },
                                          [
                                            _c("h4", {
                                              directives: [
                                                {
                                                  name: "t",
                                                  rawName: "v-t",
                                                  value:
                                                    "INPUT_LAST_NAME_ERROR",
                                                  expression:
                                                    "'INPUT_LAST_NAME_ERROR'"
                                                }
                                              ],
                                              staticClass:
                                                "menu-link up-text error-tooltip__content"
                                            }),
                                            _vm._v(" "),
                                            _c("p", {
                                              directives: [
                                                {
                                                  name: "t",
                                                  rawName: "v-t",
                                                  value:
                                                    "INPUT_LAST_NAME_ERROR_DESCRIPTION",
                                                  expression:
                                                    "'INPUT_LAST_NAME_ERROR_DESCRIPTION'"
                                                }
                                              ],
                                              staticClass: "description"
                                            })
                                          ]
                                        )
                                      : _vm._e()
                                  ]
                                )
                              ]
                            }
                          }
                        ],
                        null,
                        true
                      )
                    }),
                    _vm._v(" "),
                    _c("ValidationProvider", {
                      attrs: { rules: "required|email" },
                      scopedSlots: _vm._u(
                        [
                          {
                            key: "default",
                            fn: function({ errors }) {
                              return [
                                _c(
                                  "fieldset",
                                  {
                                    staticClass:
                                      "login-form__field input__wrap",
                                    class: { "error-focus": errors.length > 0 }
                                  },
                                  [
                                    _c("input", {
                                      directives: [
                                        {
                                          name: "model",
                                          rawName: "v-model",
                                          value: _vm.email,
                                          expression: "email"
                                        }
                                      ],
                                      ref: "emailInput",
                                      staticClass:
                                        "login-form__field__input required",
                                      class: {
                                        error: errors.length > 0,
                                        valid:
                                          _vm.email.length > 0 &&
                                          errors.length == 0
                                      },
                                      attrs: {
                                        id: "email",
                                        type: "email",
                                        name: "email",
                                        required: ""
                                      },
                                      domProps: { value: _vm.email },
                                      on: {
                                        input: function($event) {
                                          if ($event.target.composing) return
                                          _vm.email = $event.target.value
                                        }
                                      }
                                    }),
                                    _vm._v(" "),
                                    _c("label", {
                                      directives: [
                                        {
                                          name: "t",
                                          rawName: "v-t",
                                          value: "INPUT_EMAIL",
                                          expression: "'INPUT_EMAIL'"
                                        }
                                      ],
                                      staticClass: "login-form__field__label",
                                      attrs: { for: "email" }
                                    }),
                                    _vm._v(" "),
                                    errors.length > 0
                                      ? _c(
                                          "div",
                                          {
                                            staticClass: "error-tooltip__wrap"
                                          },
                                          [
                                            _c("h4", {
                                              directives: [
                                                {
                                                  name: "t",
                                                  rawName: "v-t",
                                                  value: "INPUT_EMAIL_ERROR",
                                                  expression:
                                                    "'INPUT_EMAIL_ERROR'"
                                                }
                                              ],
                                              staticClass:
                                                "menu-link up-text error-tooltip__content"
                                            }),
                                            _vm._v(" "),
                                            _c("p", {
                                              directives: [
                                                {
                                                  name: "t",
                                                  rawName: "v-t",
                                                  value:
                                                    "INPUT_EMAIL_ERROR_DESCRIPTION",
                                                  expression:
                                                    "'INPUT_EMAIL_ERROR_DESCRIPTION'"
                                                }
                                              ],
                                              staticClass: "description"
                                            })
                                          ]
                                        )
                                      : _vm._e()
                                  ]
                                )
                              ]
                            }
                          }
                        ],
                        null,
                        true
                      )
                    }),
                    _vm._v(" "),
                    _c("ValidationProvider", {
                      scopedSlots: _vm._u(
                        [
                          {
                            key: "default",
                            fn: function({ errors }) {
                              return [
                                _c(
                                  "fieldset",
                                  {
                                    staticClass:
                                      "login-form__field input__wrap",
                                    class: { "error-focus": errors.length > 0 }
                                  },
                                  [
                                    _c("input", {
                                      directives: [
                                        {
                                          name: "model",
                                          rawName: "v-model",
                                          value: _vm.phoneNumber,
                                          expression: "phoneNumber"
                                        }
                                      ],
                                      staticClass:
                                        "login-form__field__input required",
                                      class: {
                                        error: errors.length > 0,
                                        valid:
                                          _vm.phoneNumber.length > 0 &&
                                          errors.length == 0
                                      },
                                      attrs: {
                                        id: "phoneNumber",
                                        type: "text",
                                        name: "phoneNumber"
                                      },
                                      domProps: { value: _vm.phoneNumber },
                                      on: {
                                        input: function($event) {
                                          if ($event.target.composing) return
                                          _vm.phoneNumber = $event.target.value
                                        }
                                      }
                                    }),
                                    _vm._v(" "),
                                    _c("label", {
                                      directives: [
                                        {
                                          name: "t",
                                          rawName: "v-t",
                                          value: "INPUT_PHONE_NUMBER",
                                          expression: "'INPUT_PHONE_NUMBER'"
                                        }
                                      ],
                                      staticClass: "login-form__field__label",
                                      attrs: { for: "phoneNumber" }
                                    }),
                                    _vm._v(" "),
                                    errors.length > 0
                                      ? _c(
                                          "div",
                                          {
                                            staticClass: "error-tooltip__wrap"
                                          },
                                          [
                                            _c("h4", {
                                              directives: [
                                                {
                                                  name: "t",
                                                  rawName: "v-t",
                                                  value:
                                                    "INPUT_PHONE_NUMBER_ERROR",
                                                  expression:
                                                    "'INPUT_PHONE_NUMBER_ERROR'"
                                                }
                                              ],
                                              staticClass:
                                                "menu-link up-text error-tooltip__content"
                                            }),
                                            _vm._v(" "),
                                            _c("p", {
                                              directives: [
                                                {
                                                  name: "t",
                                                  rawName: "v-t",
                                                  value:
                                                    "INPUT_PHONE_NUMBER_ERROR_DESCRIPTION",
                                                  expression:
                                                    "'INPUT_PHONE_NUMBER_ERROR_DESCRIPTION'"
                                                }
                                              ],
                                              staticClass: "description"
                                            })
                                          ]
                                        )
                                      : _vm._e()
                                  ]
                                )
                              ]
                            }
                          }
                        ],
                        null,
                        true
                      )
                    }),
                    _vm._v(" "),
                    _vm.prpDetails.requireAgreementToTerms
                      ? _c("ValidationProvider", {
                          attrs: { rules: { required: { allowFalse: false } } },
                          scopedSlots: _vm._u(
                            [
                              {
                                key: "default",
                                fn: function({ errors }) {
                                  return [
                                    _c(
                                      "fieldset",
                                      {
                                        staticClass:
                                          "login-form__field login-form__field--checkbox checkbox__wrap"
                                      },
                                      [
                                        _c("input", {
                                          directives: [
                                            {
                                              name: "model",
                                              rawName: "v-model",
                                              value: _vm.agreedToTerms,
                                              expression: "agreedToTerms"
                                            }
                                          ],
                                          staticClass:
                                            "login-form__field__input--checkbox",
                                          attrs: {
                                            id: "tos.checkbox",
                                            type: "checkbox",
                                            name: "tos.checkbox"
                                          },
                                          domProps: {
                                            checked: Array.isArray(
                                              _vm.agreedToTerms
                                            )
                                              ? _vm._i(
                                                  _vm.agreedToTerms,
                                                  null
                                                ) > -1
                                              : _vm.agreedToTerms
                                          },
                                          on: {
                                            change: function($event) {
                                              var $$a = _vm.agreedToTerms,
                                                $$el = $event.target,
                                                $$c = $$el.checked
                                                  ? true
                                                  : false
                                              if (Array.isArray($$a)) {
                                                var $$v = null,
                                                  $$i = _vm._i($$a, $$v)
                                                if ($$el.checked) {
                                                  $$i < 0 &&
                                                    (_vm.agreedToTerms = $$a.concat(
                                                      [$$v]
                                                    ))
                                                } else {
                                                  $$i > -1 &&
                                                    (_vm.agreedToTerms = $$a
                                                      .slice(0, $$i)
                                                      .concat(
                                                        $$a.slice($$i + 1)
                                                      ))
                                                }
                                              } else {
                                                _vm.agreedToTerms = $$c
                                              }
                                            }
                                          }
                                        }),
                                        _vm._v(" "),
                                        _c(
                                          "label",
                                          {
                                            staticClass:
                                              "login-form__field__label login-form__field__label--checkbox",
                                            attrs: { for: "tos.checkbox" }
                                          },
                                          [
                                            _vm.prpDetails
                                              .isTermsAndConditionsURL
                                              ? _c(
                                                  "span",
                                                  [
                                                    _vm._v(
                                                      "\n            " +
                                                        _vm._s(
                                                          _vm.$t(
                                                            "PRP_TERMS_PREFIX"
                                                          )
                                                        ) +
                                                        "  "
                                                    ),
                                                    _vm.termsLinkUrl
                                                      ? _c(
                                                          "a",
                                                          {
                                                            attrs: {
                                                              href:
                                                                _vm.termsLinkUrl,
                                                              target: "_BLANK"
                                                            }
                                                          },
                                                          [
                                                            _c("u", [
                                                              _vm._v(
                                                                _vm._s(
                                                                  _vm.$t(
                                                                    "PRP_TERMS_LINK"
                                                                  )
                                                                )
                                                              )
                                                            ])
                                                          ]
                                                        )
                                                      : [
                                                          _vm._v(
                                                            _vm._s(
                                                              _vm.$t(
                                                                "PRP_TERMS_LINK"
                                                              )
                                                            )
                                                          )
                                                        ]
                                                  ],
                                                  2
                                                )
                                              : _vm._e(),
                                            _vm._v(" "),
                                            !_vm.prpDetails
                                              .isTermsAndConditionsURL
                                              ? _c("span", [
                                                  _vm._v(
                                                    "\n            " +
                                                      _vm._s(
                                                        _vm.$t(
                                                          "PRP_TERMS_PREFIX"
                                                        )
                                                      ) +
                                                      "  "
                                                  ),
                                                  _c(
                                                    "a",
                                                    {
                                                      attrs: {
                                                        href: "javascript:;"
                                                      },
                                                      on: {
                                                        click: function(
                                                          $event
                                                        ) {
                                                          return _vm.openTermsAndConditions()
                                                        }
                                                      }
                                                    },
                                                    [
                                                      _c("u", [
                                                        _vm._v(
                                                          _vm._s(
                                                            _vm.$t(
                                                              "PRP_TERMS_LINK"
                                                            )
                                                          )
                                                        )
                                                      ])
                                                    ]
                                                  )
                                                ])
                                              : _vm._e()
                                          ]
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "transition",
                                          {
                                            attrs: {
                                              name: "backend-error-fade"
                                            }
                                          },
                                          [
                                            _c(
                                              "div",
                                              {
                                                directives: [
                                                  {
                                                    name: "show",
                                                    rawName: "v-show",
                                                    value: errors.length > 0,
                                                    expression:
                                                      "errors.length > 0"
                                                  }
                                                ],
                                                staticClass: "text-center p-t-5"
                                              },
                                              [
                                                _c("p", {
                                                  directives: [
                                                    {
                                                      name: "t",
                                                      rawName: "v-t",
                                                      value: "TERMS_EROR",
                                                      expression: "'TERMS_EROR'"
                                                    }
                                                  ],
                                                  staticClass: "text-danger"
                                                })
                                              ]
                                            )
                                          ]
                                        )
                                      ],
                                      1
                                    )
                                  ]
                                }
                              }
                            ],
                            null,
                            true
                          )
                        })
                      : _vm._e(),
                    _vm._v(" "),
                    _c(
                      "fieldset",
                      {
                        staticClass:
                          "login-form__field login-form__field--button p-t-15"
                      },
                      [
                        _c(
                          "SubmitButton",
                          { attrs: { pending: _vm.isPending } },
                          [
                            _vm._v(
                              "\n        " +
                                _vm._s(_vm.$t("PRP_REGISTER_BUTTON")) +
                                "\n      "
                            )
                          ]
                        )
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "transition",
                      { attrs: { name: "backend-error-fade" } },
                      [
                        _c(
                          "div",
                          {
                            directives: [
                              {
                                name: "show",
                                rawName: "v-show",
                                value: _vm.showErrorMsg,
                                expression: "showErrorMsg"
                              }
                            ],
                            staticClass: "text-center p-t-5"
                          },
                          [
                            _c("p", { staticClass: "text-danger" }, [
                              _vm._v(
                                "\n          " +
                                  _vm._s(
                                    _vm.actionStatus.error !== ""
                                      ? _vm.actionStatus.error
                                      : _vm.$t("ORP_GENERIC_ERROR", {
                                          applicantType: _vm.applicantType
                                        })
                                  ) +
                                  "\n        "
                              )
                            ])
                          ]
                        )
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      [
                        _c("i18n", {
                          staticClass: "text-center p-t-15 prp_footer_contact",
                          attrs: { path: "ORP_FOOTER_CONTACT_EMAIL", tag: "p" },
                          scopedSlots: _vm._u(
                            [
                              {
                                key: "applicantType",
                                fn: function() {
                                  return [
                                    _vm._v(
                                      "\n          " +
                                        _vm._s(_vm.applicantType) +
                                        "\n        "
                                    )
                                  ]
                                },
                                proxy: true
                              },
                              {
                                key: "contactEmail",
                                fn: function() {
                                  return [
                                    _c(
                                      "a",
                                      {
                                        staticClass: "home_link",
                                        attrs: {
                                          href:
                                            "mailto:" +
                                            _vm.prpDetails.contactEmail,
                                          target: "_blank"
                                        }
                                      },
                                      [
                                        _vm._v(
                                          "\n            " +
                                            _vm._s(
                                              _vm.prpDetails.contactEmail
                                            ) +
                                            "\n          "
                                        )
                                      ]
                                    )
                                  ]
                                },
                                proxy: true
                              }
                            ],
                            null,
                            true
                          )
                        })
                      ],
                      1
                    )
                  ],
                  1
                )
              : _vm._e(),
            _vm._v(" "),
            _vm.isSuccess
              ? _c("div", { staticClass: "success-message text-center" }, [
                  _c("h1", {
                    directives: [
                      {
                        name: "t",
                        rawName: "v-t",
                        value: "PRP_THANK_YOU_HEADER",
                        expression: "'PRP_THANK_YOU_HEADER'"
                      }
                    ],
                    staticClass: "title md-title"
                  }),
                  _vm._v(" "),
                  _c("p", {
                    directives: [
                      {
                        name: "t",
                        rawName: "v-t",
                        value: "PRP_THANK_YOU_LINE1",
                        expression: "'PRP_THANK_YOU_LINE1'"
                      }
                    ],
                    staticClass: "subtitle"
                  }),
                  _vm._v(" "),
                  _c("p", {
                    directives: [
                      {
                        name: "t",
                        rawName: "v-t",
                        value: "ORP_THANK_YOU_LINE2",
                        expression: "'ORP_THANK_YOU_LINE2'"
                      }
                    ],
                    staticClass: "subtitle"
                  })
                ])
              : _vm._e()
          ]
        }
      }
    ])
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }